import * as React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { createContext, Dispatch, FC, SetStateAction, useContext, useState } from "react";
import { config } from "./config";
import { LocationState } from "./enums";
import { IPosition } from "./GeoLocation";
import { eng, lv } from "./language";

export interface IAppContext {
    locationState: LocationState;
    setLocationState: Dispatch<SetStateAction<LocationState>>;
    position: IPosition;
    setPosition: Dispatch<SetStateAction<IPosition>>;
    gameMode: boolean;
    setGameMode: Dispatch<SetStateAction<boolean>>;
    texts: any;
}

const url = new URL(window.location.href);
const params = new URLSearchParams(url.search.slice(1));
const languageParam = params.get("language");
// languageParam && languageParam === "eng" && (config.search.options.document.index = config.search.indexEng);
config.search.searchFields =
    languageParam && languageParam === "eng" ? config.search.fieldsENG : config.search.fieldsLV;

const AppContext = createContext<IAppContext>(null);

export const useAppContext = (): IAppContext => useContext(AppContext);

export const AppContextProvider: FC = (props: React.PropsWithChildren<IAppContext>) => {
    const [locationState, setLocationState] = useState(LocationState.Inactive);
    const [position, setPosition] = useState<IPosition>({ latitude: 0, longitude: 0 });
    const [gameMode, setGameMode] = useState<boolean>(false);

    const texts = languageParam === "eng" ? eng : lv;

    const values = {
        locationState,
        setLocationState,
        position,
        setPosition,
        gameMode,
        setGameMode,
        texts
    };

    return <AppContext.Provider value={values}>{props.children}</AppContext.Provider>;
};

const radToDeg = (radians: number) => Math.round((radians * 180) / Math.PI);
